export default __webpack_public_path__ + "static/media/5.3d432ba0.jpg";